var ReportComponent = /** @class */ (function () {
    function ReportComponent() {
    }
    ReportComponent.prototype.ngOnInit = function () {
    };
    return ReportComponent;
}());
export { ReportComponent };



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts.pre-build-optimizer.js